// extracted by mini-css-extract-plugin
export default {"image":"G5-z","loaded":"H5-z"};